import decode from 'jwt-decode'

const ACCESS_TOKEN_KEY = 'jwtToken'

export default {
  ACCESS_TOKEN_KEY,

  logout () {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY)
  },

  isAuthenticated () {
    let tokenStr = this.getAuthorizationToken()
    let token = this.verifyToken(tokenStr)

    return token !== null
  },

  // Decode the tokenStr, check the expiration and return a token object or null
  verifyToken (tokenStr) {
    if (typeof tokenStr !== 'string' || tokenStr === '') {
      return null
    }

    let token = ''
    try {
      token = decode(tokenStr)
    } catch (e) {
      return null
    }

    if (!token.exp) { return null }

    const date = new Date(0)
    const expirationDate = date.setUTCSeconds(token.exp)

    if (expirationDate < new Date()) {
      return null
    }

    return token
  },

  getAuthorizationToken () {
    if (!this.isAuthenticated) {
      return ''
    }
    return sessionStorage.getItem(ACCESS_TOKEN_KEY)
  },

  getUser () {
    let tokenStr = this.getAuthorizationToken()
    let token = this.verifyToken(tokenStr)
    return token
  },

  showBeta () {
    let tokenStr = this.getAuthorizationToken()
    let token = this.verifyToken(tokenStr)
    return (token && token.beta)
  },

  showExperimental () {
    let tokenStr = this.getAuthorizationToken()
    let token = this.verifyToken(tokenStr)
    return (token && token.experimental)
  }
}



// WEBPACK FOOTER //
// ./src/lib/auth.js